<main>
  <loading-overlay [isLoading]="isLoading() > 0"></loading-overlay>

  <header>
    <div>
      <h1>Roll Final QC</h1>
    </div>
    <div class="header-actions">
      <p-button label="Print Balance Summary" icon="pi pi-print" severity="primary" (onClick)="printBalanceSummary()" />
    </div>
  </header>

  <div class="content">
    <div class="main-layout grid-12">
      <!-- Left Column: Main Content -->
      <div class="col span-9 scroller-y">
        <p-panel header="Production Card">
          <ng-template pTemplate="icons">
            <div class="row-sm-start-center">
              <p-autocomplete
                class="w-[380px]"
                styleClass="w-full"
                inputStyleClass="w-full"
                [(ngModel)]="selectedProductionCard"
                #productionCardSearch="cslServerSearch"
                [cslServerSearch]="fetchProductionCards"
                [suggestions]="productionCardSearch.results()"
                [placeholder]="'Search production card'"
                [showClear]="true"
                [dropdown]="true"
                optionLabel="productionCardNumber"
              />
              <p-button label="Search" icon="pi pi-search" severity="primary" (onClick)="searchProductionCard()" [disabled]="!pendingProductionCard" />
            </div>
          </ng-template>

          @if (productionCard()) {
            <p-panel header="Details" data-tone="surface">
              <ng-template pTemplate="icons">
                <p-button label="Print Label" icon="pi pi-print" severity="primary" (onClick)="printAllFinalLabels()" />
                <p-button label="Balanceo" severity="primary" [outlined]="true" (onClick)="openBalanceo()" />
              </ng-template>
              <div class="col-xs">
                <p-panel [header]="'Individual_Production_Card_General_Information_OrderInformation' | translateWF: 'Order Information'">
                  <p-card>
                    <div class="grid-auto-4">
                      <div class="form-box">
                        <label for="">{{
                          'Individual_Production_Card_General_Information_WorkOrder'
                            | translateWF
                              : 'Work
                        Order'
                        }}</label>
                        <input pInputText type="text" class="w-full" [value]="workOrder?.orderNumber" disabled />
                      </div>
                      <div class="form-box">
                        <label for="">{{
                          'Individual_Production_Card_General_Information_ClientPO'
                            | translateWF
                              : 'Client
                        PO'
                        }}</label>
                        <input pInputText type="text" class="w-full" [value]="clientPO" disabled />
                      </div>
                      <div class="form-box">
                        <label for="">{{ 'Individual_Production_Card_General_Information_Client' | translateWF: 'Client' }}</label>
                        <input pInputText type="text" class="w-full" [value]="workOrder?.customer?.name" disabled />
                      </div>
                      <div class="form-box">
                        <label for="">{{ 'Individual_Production_Card_General_Information_Brand' | translateWF: 'Brand' }}</label>
                        <input pInputText type="text" class="w-full" [value]="workOrder?.brand?.name" disabled />
                      </div>
                    </div>
                  </p-card>
                </p-panel>

                <p-panel [header]="'Individual_Production_Card_General_Information_DyeingInformation' | translateWF: 'Dyeing Information'">
                  <p-card>
                    <div class="grid-auto-4">
                      <div class="form-box">
                        <label for="">{{ 'Individual_Production_Card_General_Information_Color' | translateWF: 'Color' }}</label>
                        <input pInputText type="text" class="w-full" [value]="dyeingColor?.name" disabled />
                      </div>
                      <div class="form-box">
                        <label for="">{{
                          'Individual_Production_Card_General_Information_LabDipNumber'
                            | translateWF
                              : 'Lab
                        Dip Number'
                        }}</label>
                        <input pInputText type="text" class="w-full" [value]="dyeingColor?.approvedRecipeNumber" disabled />
                      </div>
                      <div class="form-box">
                        <label for="">{{ 'Individual_Production_Card_General_Information_DyeingMachine' | translateWF: 'Dyeing Machine' }}</label>
                        <input pInputText type="text" class="w-full" [value]="dyeingAsset?.assetId" disabled />
                      </div>
                      <div class="form-box">
                        <label for="">{{
                          'Individual_Production_Card_General_Information_NoPorts'
                            | translateWF
                              : 'No.
                        Ports'
                        }}</label>
                        <input pInputText type="text" class="w-full" [value]="dyeingAsset?.dyeingMachineDetails?.numberOfPorts" disabled />
                      </div>
                    </div>
                  </p-card>
                </p-panel>
              </div>
            </p-panel>
          }
        </p-panel>

        @if (productionCard()) {
          <p-panel header="Rolls with Final Weight">
            <ng-template pTemplate="icons">
              <p-inputgroup>
                <p-inputgroup-addon>
                  <i class="pi pi-search"></i>
                </p-inputgroup-addon>
                <input pInputText [formControl]="rollFilterControl" placeholder="Filter by roll number or scan..." class="filter-input" />
              </p-inputgroup>
              @if (rollFilterControl.value) {
                <p-button icon="pi pi-times" [text]="true" severity="secondary" (onClick)="clearFilter()" />
              }
            </ng-template>
            <div class="col-sm">
              <!-- Batch Actions Section -->
              <p-panel header="Batch Actions" data-tone="surface">
                <p-card data-variant="flat">
                  <div class="row-between-center">
                    <p-inputgroup>
                      <p-inputgroup-addon>Set GSM</p-inputgroup-addon>
                      <p-inputNumber [(ngModel)]="batchGsmValue" [min]="0" placeholder="GSM" [inputStyle]="{ width: '80px' }" />
                      <p-button label="Apply" (onClick)="applyBatchGsm()" [disabled]="!batchGsmValue || batchGsmValue <= 0" />
                    </p-inputgroup>

                    <p-inputgroup data-variant="compact">
                      <p-inputgroup-addon>QC Action</p-inputgroup-addon>
                      <p-button label="Approve All" icon="pi pi-check" severity="success" (onClick)="approveAll()" [disabled]="getEditableRollCount() === 0" />
                      <p-button label="Reject All" icon="pi pi-ban" severity="danger" (onClick)="rejectAll()" [disabled]="getEditableRollCount() === 0" />
                    </p-inputgroup>
                  </div>
                </p-card>
              </p-panel>
              <p-panel data-tone="surface">
                <ng-template pTemplate="icons">
                  <p-button
                    [label]="'Save All (' + getPendingChangeCount() + ' rolls)'"
                    icon="pi pi-save"
                    severity="primary"
                    (onClick)="saveAllPendingChanges()"
                    [disabled]="getPendingChangeCount() === 0"
                  />
                </ng-template>
                <p-card data-variant="compact">
                  <app-rolls-display-table #rollsTable [rolls]="filteredRolls()" [fabrics]="fabrics()" [viewMode]="'final-qc'" class="cs-datatable-dense" />
                </p-card>
              </p-panel>
            </div>
            <ng-template pTemplate="footer">
              <span>Showing {{ filteredRolls().length }} of {{ rolls().length }} rolls with final weight</span>
            </ng-template>
          </p-panel>
        }
      </div>

      <!-- Right Column: QC Summary Sidebar -->
      <div class="span-3 scroller-y">
        <p-panel header="Work Order QC Summary">
          <ng-template pTemplate="icons">
            <p-button label="Cuadraje" severity="primary" [outlined]="true" [disabled]="!canOpenCuadraje" (onClick)="openCuadraje()" />
          </ng-template>

          @if (qcSummary()) {
            <p-panel [header]="qcSummary()!.workOrderNumber">
              <p-card>
                <!-- Grand Total Summary -->
                <div class="mb-4 p-3 surface-ground border-round">
                  <div class="font-semibold mb-2 text-sm">Overall Progress</div>
                  <div class="grid-3-xs mb-2 w-full">
                    <div class="text-center p-2 surface-card border-round w-full">
                      <div class="text-xs text-gray-500">Total</div>
                      <div class="text-lg font-semibold">{{ qcSummary()!.grandTotal.totalRolls }}</div>
                    </div>
                    <div class="text-center p-2 surface-card border-round w-full">
                      <div class="text-xs text-gray-500">Weighed</div>
                      <div class="text-lg font-semibold">{{ qcSummary()!.grandTotal.weighedRolls }}</div>
                    </div>
                    <div class="text-center p-2 surface-card border-round w-full">
                      <div class="text-xs text-gray-500">Approved</div>
                      <div class="text-lg font-semibold text-green-500">{{ qcSummary()!.grandTotal.approvedRolls }}</div>
                    </div>
                    <div class="text-center p-2 surface-card border-round w-full">
                      <div class="text-xs text-gray-500">Rejected</div>
                      <div class="text-lg font-semibold text-red-500">{{ qcSummary()!.grandTotal.rejectedRolls }}</div>
                    </div>
                    <div class="text-center p-2 surface-card border-round w-full">
                      <div class="text-xs text-gray-500">Pending</div>
                      <div class="text-lg font-semibold text-orange-500">{{ qcSummary()!.grandTotal.pendingRolls }}</div>
                    </div>
                    <div class="text-center p-2 surface-card border-round w-full">
                      <div class="text-xs text-gray-500">Left Over</div>
                      <div class="text-lg font-semibold text-gray-500">
                        {{ qcSummary()!.grandTotal.leftOverAssignableRolls + qcSummary()!.grandTotal.leftOverNotAssignableRolls }}
                      </div>
                    </div>
                  </div>
                  <div class="flex flex-col gap-1 text-sm">
                    <div class="flex justify-between">
                      <span class="text-gray-500">Approved:</span>
                      <span class="font-medium text-green-500">{{ qcSummary()!.grandTotal.approvedWeightLbs | number: '1.2-2' }} lbs</span>
                    </div>
                    <div class="flex justify-between">
                      <span class="text-gray-500">Pending:</span>
                      <span class="font-medium text-orange-500">{{ qcSummary()!.grandTotal.pendingWeightLbs | number: '1.2-2' }} lbs</span>
                    </div>
                  </div>
                </div>

                <!-- Fabric Summaries -->
                <div class="flex flex-col gap-[0.75rem]">
                  @for (fabric of qcSummary()!.fabricSummaries; track fabric.fabricCode) {
                    <p-fieldset [legend]="fabric.fabricCode" styleClass="cs-fieldset-nested">
                      @if (fabric.fabricDescription) {
                        <div class="text-xs text-gray-500 mb-2">{{ fabric.fabricDescription }}</div>
                      }

                      <!-- Progress Bar -->
                      <div class="mb-2">
                        <div class="flex justify-between text-xs text-gray-500 mb-1">
                          <span>Required: {{ fabric.requiredWeightLbs | number: '1.2-2' }} lbs</span>
                          <span class="font-semibold" [ngClass]="fabric.isOverCapacity ? 'text-red-500' : 'text-primary'">
                            {{ fabric.progressPercentage | number: '1.2-2' }}%
                          </span>
                        </div>
                        <div class="progress-bar-container">
                          <div
                            class="progress-bar-fill"
                            [ngClass]="{ 'over-capacity': fabric.isOverCapacity }"
                            [style.width.%]="fabric.progressPercentage > 100 ? 100 : fabric.progressPercentage"
                          ></div>
                        </div>
                        @if (fabric.isOverCapacity) {
                          <div class="text-xs text-red-500 mt-1">
                            <i class="pi pi-exclamation-triangle mr-1"></i>
                            Excess: {{ fabric.excessWeightLbs | number: '1.2-2' }} lbs
                          </div>
                        } @else if (fabric.remainingWeightLbs > 0) {
                          <div class="text-xs text-gray-500 mt-1">Remaining: {{ fabric.remainingWeightLbs | number: '1.2-2' }} lbs</div>
                        }
                      </div>

                      <!-- Fabric Totals -->
                      <div class="text-xs mb-2">
                        <div class="text-green-500">
                          Approved: {{ fabric.fabricTotal.approvedRolls }} ({{ fabric.fabricTotal.approvedWeightLbs | number: '1.2-2' }}
                          lbs)
                        </div>
                        <div class="text-orange-500">Pending: {{ fabric.fabricTotal.pendingRolls }} ({{ fabric.fabricTotal.pendingWeightLbs | number: '1.2-2' }} lbs)</div>
                        @if (fabric.fabricTotal.rejectedRolls > 0) {
                          <div class="text-red-500">
                            Rejected: {{ fabric.fabricTotal.rejectedRolls }} ({{ fabric.fabricTotal.rejectedWeightLbs | number: '1.2-2' }}
                            lbs)
                          </div>
                        }
                      </div>

                      <!-- Production Cards -->
                      @if (fabric.productionCards.length > 0) {
                        <div class="border-t border-gray-200 pt-2">
                          @for (pc of fabric.productionCards; track pc.productionCardId) {
                            <div
                              class="pc-item flex items-center gap-2 p-2 border-round text-xs"
                              [ngClass]="{ current: pc.productionCardNumber === productionCard()?.productionCardNumber }"
                            >
                              <div class="font-medium flex-1">{{ pc.productionCardNumber }}</div>
                              @if (pc.colorName) {
                                <div class="text-gray-500">{{ pc.colorName }}</div>
                              }
                              <div class="flex gap-2">
                                <span class="font-semibold text-green-500" title="Approved">{{ pc.summary.approvedRolls }}</span>
                                <span class="font-semibold text-orange-500" title="Pending">{{ pc.summary.pendingRolls }}</span>
                                @if (pc.summary.rejectedRolls > 0) {
                                  <span class="font-semibold text-red-500" title="Rejected">{{ pc.summary.rejectedRolls }}</span>
                                }
                              </div>
                            </div>
                          }
                        </div>
                      }
                    </p-fieldset>
                  }
                </div>
              </p-card>
            </p-panel>
          } @else {
            <div class="qc-summary-empty w-full h-[200px]">
              <span>Selecciona una production card</span>
            </div>
          }
        </p-panel>
      </div>
    </div>
  </div>
</main>

<p-toast position="top-center" />
